import type { TripArea } from '@trippath/shared';

import { metresApart } from './recording';

/** Whether each area holds a point, by its id. */
export type Inside = Record<string, boolean>;

/**
 * The areas a point is in, and those crossed since the point before: an area not yet known is
 * only noted — a recording begun inside the hotel is no arrival.
 */
export function crossings(
  before: Inside,
  areas: readonly TripArea[],
  at: { lat: number; lon: number },
): { inside: Inside; crossed: { id: string; arrived: boolean }[] } {
  const inside: Inside = Object.fromEntries(
    areas.map((area) => [area.id, metresApart(area, at) <= area.radius]),
  );
  const crossed = areas
    .filter((area) => area.id in before && before[area.id] !== inside[area.id])
    .map((area) => ({ id: area.id, arrived: inside[area.id] === true }));
  return { inside, crossed };
}
